import {cn} from "../../utils/helper";

interface CtaBannerProps {
    message: string
    buttonText: string
    href?: string
    className?: string
}

export default function CtaBanner({
                                      message,
                                      buttonText,
                                      href = '#',
                                      className,
                                  }: CtaBannerProps) {
    return (
        <div
            className={cn(
                '-mx-4 md:rounded-2xl bg-[#E6F0FE] ring-1 ring-sky-100 px-6 py-6 sm:px-8 sm:py-9 gap-[10px] md:gap-0 flex flex-col md:flex-row items-center justify-between',
                className,
            )}
        >
            <p className="block md:hidden text-[#0D0D0D] leading-[28px] font-[600] text-[18px] md:text-[20px]">{message.split('\\n').map((txt,i) => <span className={'block text-center'} key={i}>{txt}</span>)}</p>
            <p className="hidden md:block text-[#0D0D0D] leading-[39px] font-[600] text-[18px]">{message.replace(/\\n/g, "")}</p>
            <a
                href={href}
                className="inline-flex items-center gap-2 rounded-md bg-[#0000ED] px-[28px] py-[11px] text-white text-[16px] md:text-[18px] font-[600] focus-ring"
            >
                {buttonText}
            </a>
        </div>
    )
}
